<template>
  <div v-if="currentUser.is_admin" class="permission-settings" ref="permission-settings-text">
    <v-row class="mx-6">
      <v-col cols="12" md="5">
        <v-autocomplete
          v-model="selected_user"
          :items="staff"
          outlined
          color="primary"
          label="Select User"
          hide-details
          dense
          background-color="transparent"
          item-value="id"
          item-text="full_name"
          class="mb-4 rounded-input"
          return-object
          @change="getStaffPrivileges();handleTourAfterClick();"
        >
          <template v-slot:item="data">
            <template>
              <v-list-item-content>
                <v-list-item-title
                  v-html="data.item.full_name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="data.item.username"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col v-if="selected_user" cols="12" md="3"><p class="mt-2">Use Ctrl+F to search</p></v-col>
      <v-col v-if="selected_user && showSaveButton" cols="12" md="3" sm="6">
        <v-btn id="revert-changes" block @click="getStaffPrivileges">Revert Changes</v-btn>
      </v-col>
      <v-col v-if="selected_user && showSaveButton" cols="12" md="1" sm="6">
        <v-btn id="save-changes-permission" block color="primary" @click="sendSelectedPrivileges">Save</v-btn>
      </v-col>
    </v-row>

    <v-row v-masonry v-if="selected_user" class="mx-4">
      <v-col
        v-masonry-tile
        v-for="privilegeGroup in Object.keys(privileges)"
        :key="privilegeGroup"
        cols="12"
        md="4"
      >
        <v-card>
          <v-card-title class="mb-0 pb-0">{{ privilegeGroup }}</v-card-title>
          <v-checkbox
            v-model="privilegeGroupSelectAllStatus[privilegeGroup]"
            class="ml-4 mt-0 bold-checkbox-text"
            @change="toggleSelectAllForPrivilegeGroup(privilegeGroup);CheckboxTourAfterClick();"
            label="Select All"
          ></v-checkbox>

          <v-list dense>
            <v-list-item
              v-for="privilege in privileges[privilegeGroup]"
              :key="privilege.nickname"
            >
              <v-checkbox
                v-model="privilege.is_granted"
                @change="privilegeCheckedCallback(privilege);CheckboxTourAfterClick();"
                class="my-0 mx-0"
              >
                <template v-slot:label>
                  <div v-html="privilege.title"></div>
                </template>
              </v-checkbox>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col><h2>Select a staff account to manage permissions.</h2></v-col>
    </v-row>
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import TourHelper from "@utils/tour_helper";


export default {
  name: "PermissionSettings",
  data() {
    return {
      queries: ["staff"],
      search: "",
      privilegeGroupSelectAllStatus: {},
      selected_user: null,
      staff: [],
      showSaveButton: false,
      privileges: [],
      snackbar: {
        visible: false,
        text: "",
      },
    };
  },

  filters: {
    highlight: function (value) {
      return value;
    },
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),

    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Welcome to Permission Settings", description: "Check and set permissions of different staff under this section.", videoLink: "https://youtube.com"});
        // steps.push({id: '2', description: "Reset the whole row information.", position:'top' ,el: '#reset-row'});
        // steps.push({id: '3', description: "Select a classroom for further instructions", position:'top' ,el: '#add-row-item'});
        // steps.push({id: '4', description: "Select a classroom for further instructions", position:'top' ,el: '#save-timetable'});
        TourHelper.startTour(this, "permissions", steps);
    },

    handleTourAfterClick() {
        var steps = [];
        steps.push({id: '1', Title:"Staff Permissions",description: "Here different modules access can be given or changed for different staff by changing status of checkbox, click on any select all checkbox for further instructions."});
        // steps.push({id: '2', description: "Reset the whole row information.", position:'top' ,el: '#reset-row'});
        // steps.push({id: '3', description: "Select a classroom for further instructions", position:'top' ,el: '#add-row-item'});
        // steps.push({id: '4', description: "Select a classroom for further instructions", position:'top' ,el: '#save-timetable'});
        TourHelper.startTour(this, "permissions__after__click", steps);
    },
    CheckboxTourAfterClick() {
        var steps = [];
        steps.push({id: '1', description: "Fill in all necessary information(which are * marked), if break is selected then just timeslot is required."});
        steps.push({id: '2', description: "Revert Changes for selected permission." ,el: '#revert-changes'});
        steps.push({id: '3', description: "Save the changes that you've made after changing status." ,el: '#save-changes-permission'});
        // steps.push({id: '4', description: "Select a classroom for further instructions", position:'top' ,el: '#save-timetable'});
        TourHelper.startTour(this, "permissions__after__checkbox__click", steps);
    },

    async checkAndActivateSelectAllForSpecificPrivilegeGroup() {
      Object.keys(this.privileges).map((privilegeGroup) => {
        // check if all privileges are active
        var unselectedFound = false;
        this.privileges[privilegeGroup].map((privilege) => {
          if (!privilege.is_granted) unselectedFound = true;
        });
        this.privilegeGroupSelectAllStatus[privilegeGroup] = !unselectedFound;
      });
    },

    async privilegeCheckedCallback(privilege) {
      this.showSaveButton = true;
      if (privilege.is_granted) this.enableDependencies(privilege);
      else this.disableChildren(privilege);

      this.checkAndActivateSelectAllForSpecificPrivilegeGroup();
    },

    // recursively enables all dependencies for a particular privilege
    async enableDependencies(privilege) {
      privilege.dependencies.map((dependency) => {
        var dependencyPrivilege = this.getAllPrivilegesList().find(
          (p) => p.id == dependency
        );
        dependencyPrivilege.is_granted = true;
        this.enableDependencies(dependencyPrivilege); // do the same for multilevel dependencies
      });
    },

    // recursively disables all children for a particular privilege
    async disableChildren(privilege) {
      privilege.children.map((child) => {
        var childPrivilege = this.getAllPrivilegesList().find(
          (p) => p.id == child
        );
        childPrivilege.is_granted = false;
        this.disableChildren(childPrivilege); // do the same for multilevel dependencies
      });
    },

    // gives a plain list of all privileges from Privileges Groups
    getAllPrivilegesList() {
      var list = [];
      Object.keys(this.privileges).map((privilegeCategory) => {
        this.privileges[privilegeCategory].map((privilege) => {
          list.push(privilege);
        });
      });
      return list;
    },

    // gets a list of selected privileges and sends to server
    async sendSelectedPrivileges() {
      var selectedPrivileges = [];
      Object.keys(this.privileges).map((privilegeCategory) => {
        this.privileges[privilegeCategory].map((privilege) => {
          if (privilege.is_granted) selectedPrivileges.push(privilege.id);
        });
      });
      var body = {
        staff_id: this.selected_user.id,
        privileges: selectedPrivileges,
      };
      var response = await api.call(
        this.apiEssentials,
        endpoints.saveStaffPrivileges,
        api.Methods.POST,
        body
      );
      if (response) {
        this.snackbar.text = "User permissions successfully saved";
        this.snackbar.visible = true;
        this.showSaveButton = false;
      }
    },

    async toggleSelectAllForPrivilegeGroup(privilegeGroup) {
      var selectAll = this.privilegeGroupSelectAllStatus[privilegeGroup];
      this.privileges[privilegeGroup].map((p) => {
        p.is_granted = selectAll;
        if (p.is_granted) this.enableDependencies(p);
        else this.disableChildren(p);
      });
      this.showSaveButton = true;
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    async getAllStaff() {
      var url = endpoints.getOnlyFaculty;
      url = Helper.addUrlParams(url, 'all=true');
      this.staff = await api.call(this.apiEssentials, url);
    },

    async getStaffPrivileges() {
      this.privileges = [];
      var url = Helper.addUrlParams(
        endpoints.getStaffPrivileges,
        "staff_id=" + this.selected_user.id
      );
      this.privileges = await api.call(this.apiEssentials, url);
      this.showSaveButton = false;
      this.checkAndActivateSelectAllForSpecificPrivilegeGroup();
    },
  },
  created() {
    this.getAllStaff();
    this.handleTour();
  },
  mounted() {
    // Code that will run only after the
    // entire view has been rendered
  },
};
</script>

<style scoped>
.bold-checkbox-text {
  font-weight: bold;
}
.highlightText {
  background-color: orange;
}
</style>